module.exports = __webpack_public_path__ + "media/V28.4236c35b.mp4";